import React from 'react';
import { Flex, xcss } from '@atlaskit/primitives';
import Heading from '@atlaskit/heading';
// @ts-ignore
import EmptyWidget from './assets/empty-widget.png';
import EmptyWidgetV2 from './assets/empty-widget-v2.svg';
import './widget-empty.scss';

const widgetBoxStyles = xcss({
  height: '100%',
});

export const WidgetEmpty = ({ version }: { version?: number }) => {
  if (version === 2) {
    return (
      <Flex direction="column" justifyContent="center" alignItems="center" gap="space.300" xcss={widgetBoxStyles}>
        <Flex justifyContent="center">
          {/* @ts-ignore */}
          <img src={EmptyWidgetV2} alt="empty-widget" width="160" height="160" />
        </Flex>
        <Heading size="medium">No data to show</Heading>
      </Flex>
    );
  }

  return (
    <div className="ppc-widget-empty flex-column justify-center">
      <div>
        <img src={EmptyWidget} alt="empty-widget" width="290" height="260" />
        <p className="empty-widget-heading mt-24">No data to show</p>
      </div>
    </div>
  );
};
